<div class="cald_dialog">
  <div class="cald_header">
    <button class="close-dialog-button sap-icon" data-dismiss="modal" (click)="cancel()">&#xe03e;</button>
    <h2>{{'CtxSyntaxChecker.Title' | translate}}</h2>
  </div>
  <div class="cald_content ctx-formula-builder-content">
    <div class="ctx-help">
      <span>{{'Admin.Msg.Help' | translate}}</span>
      <a href="https://help.sap.com/docs/SAP_CPQ/884885f05e6b4c8082254d4d9d63f19b/adea1bd0df4e48dbbed811a22b67e672.html" target="_blank">
        <span class="sap-icon">&#xe1c3;</span>
      </a>
    </div>

    <!-- Initial component -->
    <div class="row">
      <div class="col-6">
        <cpq-select (onChange)="initalTagSelected(+$event)" [id]="'initalTagSelect'"
          [type]="SelectType.Searchable" [label]="{key: 'FormulaBuilder_CTX_SelectObject', placeholder:'FormulaBuilder.StartTyping'}"
          [items]="initialTags"
          [tabindex]="-1">
        </cpq-select>
      </div>
      <div class="col-6">
        @if (selectedTags[0]) {
          <div>
            <div class="form-group flex argument-select">
              @if (selectedTags[0] && !selectedTags[0].hasEditableArgument && selectedTags[0].hasArgument && selectedTags[0].arguments) {
                <cpq-select
                  id="selectArgument{{0}}" #selectArgument
                  (onChange)="argumentSelected(+$event, 0)"
                  [type]="SelectType.Searchable"
                  [label]="{key: 'Select ' + selectedTags[0].text + ' Argument', placeholder:'FormulaBuilder.StartTyping'}"
                  [items]="selectedTags[0].arguments">
                </cpq-select>
              }
              @if (selectedTags[0] && selectedTags[0].hasEditableArgument && selectedTags[0].hasArgument && selectedTags[0].arguments) {
                <cpq-input
                  id="firstInputArgument" #firstInputArgument
                  [(ngModel)]="selectedTags[0].argument"
                  [label]="{key: 'Enter ' + selectedTags[0].text + ' Argument', placeholder:'FormulaBuilder.StartTyping'}"
                  (ngModelChange)="insertEditableArgument()">
                </cpq-input>
              }
              @if (selectedTags[0] && selectedTags[0].hasArgument) {
                <button type="button" id="selectArgumentType" (click)="switchToEditableArgument(selectedTags[0])">
                  @if (!selectedTags[0].hasEditableArgument) {
                    <span title="{{'CtxSyntaxChecker.ShowEditableArgument' | translate}}" class="sap-icon">&#xe1A3;</span>
                  }
                  @if (selectedTags[0].hasEditableArgument) {
                    <span title="{{'CtxSyntaxChecker.ShowDropdownArgument' | translate}}" class="sap-icon">&#xe170;</span>
                  }
                </button>
              }
            </div>
          </div>
        }
      </div>
    </div>
    <!-- End of initial component -->

    <!-- Components for other tags -->
    @for (tag of selectedTags; track tag; let i = $index) {
      <div>
        @if (tag.children && tag.children.length > 0) {
          <div>
            <div class="row">
              <div class="col-6">
                <cpq-select (onChange)="tagSelected(+$event, tag.children, i + 1)"
                  id="selectObject{{i+1}}" #selectObject
                  [type]="SelectType.Searchable"
                  [label]="{key: 'Select ' + selectedTags[i].text + ' Object', placeholder:'FormulaBuilder.StartTyping'}"
                  [items]="tag.children">
                </cpq-select>
              </div>
              <div class="col-6">
                <div class="form-group flex argument-select">
                  @if (selectedTags[i+1] && !selectedTags[i+1].hasEditableArgument && selectedTags[i+1].hasArgument && selectedTags[i+1].arguments) {
                    <cpq-select
                      id="selectArgument{{i+1}}" #selectArgument
                      (onChange)="argumentSelected(+$event, i+1)"
                      [type]="SelectType.Searchable"
                      [label]="{key: 'Select ' + selectedTags[i+1].text + ' Argument', placeholder:'FormulaBuilder.StartTyping'}"
                      [items]="selectedTags[i+1].arguments">
                    </cpq-select>
                  }
                  @if (selectedTags[i+1] && selectedTags[i+1].hasEditableArgument && selectedTags[i+1].hasArgument && selectedTags[i+1].arguments) {
                    <cpq-input
                      id="inputArgument{{i+1}}" #inputArgument
                      [(ngModel)]="selectedTags[i+1].argument"
                      [label]="{key: 'Enter ' + selectedTags[i+1].text + ' Argument', placeholder:'FormulaBuilder.StartTyping'}"
                      (ngModelChange)="insertEditableArgument()">
                    </cpq-input>
                  }
                  @if (selectedTags[i+1] && selectedTags[i+1].hasArgument) {
                    <button type="button" id="selectArgumentType" (click)="switchToEditableArgument(selectedTags[i+1])">
                      @if (!selectedTags[i+1].hasEditableArgument) {
                        <span title="{{'CtxSyntaxChecker.ShowEditableArgument' | translate}}" class="sap-icon">&#xe1A3;</span>
                      }
                      @if (selectedTags[i+1].hasEditableArgument) {
                        <span title="{{'CtxSyntaxChecker.ShowDropdownArgument' | translate}}" class="sap-icon">&#xe170;</span>
                      }
                    </button>
                  }
                </div>
              </div>
            </div>
          </div>
        }
      </div>
    }

    <!-- End of Components for other tags -->
    <div class="operator-background">
      <label>{{'CtxSyntaxChecker.YourCtxTag' | translate}}</label>
      <p>{{ctxFormula}}</p>
    </div>
    @if (errorMessage) {
      <div class="alert alert-danger">
        <span class="sap-icon">&#xe1c7;</span>
        <div class="content">
          {{errorMessage}}
        </div>
      </div>
    }
  </div>
  <div class="form-inline cald_dialog_buttonbar">
    <button type="button" class="btn btn-primary fiori3-btn-primary" id="pushCtxTagToFormula" (click)="pushCtxTagToFormula(ctxFormula)">{{'Admin.Msg.Insert' | translate}}</button>
    <button type="button" class="btn btn-tertiary fiori3-btn-tertiary" id="cancel" (click)="cancel()">{{'Msg.Close' | translate}}</button>
  </div>
</div>
